// authPages/autoLoginInvoiceView.tsx

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import rest from '@data/restWrapper';
import useStore from '@data/state/zustand';
import pubsub from '@data/pubsub';
import PageLoader from '@components/loaders/loader1';
import InvoicePrintView from '../pages/checkoutAndInvoice/printView/PrintView'; // adjust path
import PageNotFound from '@pages/pageNotFound';

const AutoLoginInvoiceView = (props: any) => {
    const [searchParams] = useSearchParams();
    const userUuid = searchParams.get('userUuid');
    
    const [status, setStatus] = useState<'loading' | 'authenticated' | 'error'>('loading');
    const authTokenInfo = useStore((state) => state.authTokenInfo);

    // Auto-login
    useEffect(() => {
        const autoLogin = async () => {
            if (authTokenInfo?.token) {
                setStatus('authenticated');
                return;
            }

            if (!userUuid) {
                setStatus('error');
                return;
            }

            try {
                const tokenInfo = await rest('/autoLoginUser/' + userUuid, 'GET');
                useStore.getState().setNestedProperty(['authTokenInfo'], tokenInfo);
                const userEmail = tokenInfo?.user?.email;
                //@ts-ignore
                pubsub.emit('loginSuccess', userEmail);
                setStatus('authenticated');
            } catch (err) {
                console.error('Auto-login failed:', err);
                setStatus('error');
            }
        };

        autoLogin();
    }, [userUuid, authTokenInfo?.token]);

    // Cleanup na zatvaranje taba (samo za auto-login sessione)
    useEffect(() => {
        if (!userUuid) return;

        const handleBeforeUnload = () => {
            useStore.getState().setNestedProperty(['authTokenInfo'], null);
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [userUuid]);

    if (status === 'loading') {
        return <PageLoader header="Authenticating..." />;
    }

    if (status === 'error') {
        return <PageNotFound />;
    }

    return <InvoicePrintView {...props} />;
};

export default AutoLoginInvoiceView;